import { FormFile, Model } from "@/types";

interface RmaOptions {
  rmaId?: number;
  model: Model;
  reasonForReturn: number;
  serialnumber: string;
  faultDescription: string;
  transportHanexShipping: boolean;
  dateOfPurchase: string;
  transportOriginalPackaging: boolean;
  transportSecurePacking: boolean;
  transportUpsPickup: boolean;
  clientReference: string;
  externalReference: string;
  packageWeight: number;
  packageHeight: number;
  packageLength: number;
  packageWidth: number;
  upsPickupPreveredDate: string;
  priceQuotation: number;
  files: FormFile[];
  receipt: FormFile;
  transportCouponCode: string;
  dealerOptionsCustomerName: string;
  dealerOptionsCustomerEmail: string;
  dealerOptionsCustomerPhone: string;
  dealerOptionsCustomerAttention: string;
  dealerOptionsCustomerAddress: string;
  dealerOptionsCustomerAddress2: string;
  dealerOptionsCustomerCity: string;
  dealerOptionsCustomerCountry: string;
  dealerOptionsCustomerPostal: string;
  dealerOptionsCustomerMessage: string;
  dealerOptionsContactDirectly: number;
  dealerOptionsPickupDirectly: boolean;
  dealerOptionsRetourDirectly: boolean;
  rmaConfirmationState: number;
}

export default class Rma implements RmaOptions {
  rmaId = 0;
  model = { fmId: 0, name: "", make: { fmId: 0, name: "" }, graphic: "" };
  reasonForReturn = 0;
  serialnumber = "";
  faultDescription = "";
  transportHanexShipping = false;
  dateOfPurchase = "";
  transportOriginalPackaging = true;
  transportSecurePacking = true;
  transportUpsPickup = false;
  clientReference = "";
  externalReference = "";
  packageWeight = 0;
  packageHeight = 0;
  packageLength = 0;
  packageWidth = 0;
  upsPickupPreveredDate = "";
  priceQuotation = 0;
  files: FormFile[] = [];
  receipt: FormFile = { filename: "", mimetype: "", originalname: "", size: 0 };
  transportCouponCode = "";
  dealerOptionsCustomerName = "";
  dealerOptionsCustomerAttention = "";
  dealerOptionsCustomerEmail = "";
  dealerOptionsCustomerPhone = "";
  dealerOptionsCustomerAddress = "";
  dealerOptionsCustomerAddress2 = "";
  dealerOptionsCustomerCity = "";
  dealerOptionsCustomerCountry = "";
  dealerOptionsCustomerPostal = "";
  dealerOptionsCustomerMessage = "";
  dealerOptionsContactDirectly = -1;

  dealerOptionsPickupDirectly = false;
  dealerOptionsRetourDirectly = false;
  rmaConfirmationState = -1;

  constructor(options?: RmaOptions) {
    if (!options) return;

    for (const key in options) {
      if (Object.prototype.hasOwnProperty.call(options, key) === false)
        continue;

      this[key] = options[key];
    }
  }
}
